import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Button, Loader, Popup, Checkbox } from 'semantic-ui-react';
import Modal from '../Modal';

import '../../css/LearnosityScoringModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import { VIEW_SELECTION } from '../../managers/NavigationManager';

import { DIALOG_NAMES } from '../../managers/DialogManager';

import UtilityService from '../../services/UtilityService';

import { setSessionStorageItem } from '../../utils/session';

export default
@inject('learnosityItemsManager', 'assignmentManager', 'userManager', 'learnosityDataManager', 'gradebookManager', 'dialogManager')
@observer
class LearnosityScoringModal extends Component {
  gradingApp;
  totalPoints = 0;
  totalMaxPoints = 0;
  updatedResponses = false;

  constructor(props) {
    super(props);
    this.state = {
      activitySessionId: '',
      addInfoOpen: false,
      allItemsAttached: false,
      attachedItemCount: 0,
      cancelStart: false,
      curActivityInstanceId: '',
      curStudentId: '',
      dirtyInstances: new Map(),
      doClose: false,
      errorMessage: '',
      forceStudentNavigation: false,
      instanceStatus: '',
      isGradingAPILoaded: false,
      isSaving: false,
      isStudentStarted: false,
      isStudentSubmitted: false,
      itemCount: 0,
      learnosityDataLoaded: false,
      overallScore: 0,
      questionData: null,
      renderingItems: false,
      responseData: null,
      saveComplete: true,
      showAttachingSpinner: false,
      showErrorDialog: false,
      showStudentName: true,
      showStudentNavigation: false,
      showSubmissionMessage: false,
      studentName: '',
      unattemptedResponseIds: [],
      unscoredItemsCount: 0
    };
    this.InfoModal = SatCoreComponent('InfoModal');
    this.ErrorModal = SatCoreComponent('ErrorModal');
  }

  async componentDidMount() {
    const { activityInstanceId, activityInstances, currentActivityInstance, grade, studentId, studentName } = this.props;

    // Add Grading api script
    if (!document.getElementById('learnosity-script') ||
      !document.getElementById('learnosity-script').attributes.src.value.includes('grading.learnosity')) {
      const script = document.createElement('script');
      script.src = 'https://grading.learnosity.com/?v2025.1.LTS';
      script.async = true;
      document.body.appendChild(script);
    }

    if (currentActivityInstance && activityInstances.size > 0) {
      const instanceStudentName = `${currentActivityInstance.firstName} ${currentActivityInstance.lastName}`;
      this.setState({ studentName: instanceStudentName, showStudentNavigation: true });
    } else {
      this.setState({ studentName });
    }

    this.setState({ curActivityInstanceId: activityInstanceId, curStudentId: studentId, overallScore: grade });

    // Call to get data needed to render view
    this.getLearnosityData(activityInstanceId);

  }

  async componentDidUpdate() {
    const { curActivityInstanceId, isGradingAPILoaded, renderingItems, doClose, instanceStatus } = this.state;
    // if this is the first time, load the activity
    console.log(`in componentDidUpdate: renderingItems: ${renderingItems} isGradingAPILoaded: ${isGradingAPILoaded} instanceStatus: ${instanceStatus}`);//remove
    if (!renderingItems && isGradingAPILoaded && (instanceStatus !== 'pending-submit')) {
      this.renderGradingItems();
    }
    if (doClose) {
      await this.props.closeModalCallback(curActivityInstanceId);
    }
  }

  async getLearnosityData(activityInstanceId) {
    const { learnosityDataManager } = this.props;
    let instanceStatus = 'ready';
    let isStudentSubmitted = false;
    let isStudentStarted = false;
    learnosityDataManager.getLearnosityDataApiResponseScores(activityInstanceId).then( async (data) => {
      if (data) {
        if (data.instanceStatus) {
          instanceStatus = data.instanceStatus;
        }
        if (data.isStudentSubmitted) {
          isStudentSubmitted = data.isStudentSubmitted;
        }
        if (data.isStudentStarted) {
          isStudentStarted = data.isStudentStarted;
        }
        console.log(`in getLearnosityData: instanceStatus: ${instanceStatus} isStudentSubmitted: ${isStudentSubmitted} isStudentStarted: ${isStudentStarted}`);//remove
        if (data.status && data.status === 'SUCCESS') {
          if (data.sessionsScores && data.questions) {
            const responseJSON = JSON.parse(data.sessionsScores);
            const questionData = data.questions;
            learnosityDataManager.setResponseJSON(responseJSON);
            learnosityDataManager.setQuestionData(questionData);
            this.setState({ responseData: responseJSON.responses, questionData, instanceStatus, isStudentSubmitted, isStudentStarted});
          }
          await this.startLoadGradingApp();
        } else {
          if (data.statusMessage) {
            if (data.code && data.code.length > 0 && (instanceStatus === 'ready' || instanceStatus === 'closed')) {
              this.handleSubmitSessionConfirm(activityInstanceId);
              this.setState({ showSubmissionMessage: true });
            } else {
              this.openWarningModal(data.statusMessage);
            }
            console.error(`No question data found for assignment: ${activityInstanceId}, code: {code ? code : 'n/a'} message: ${data.statusMessage}`); // TODO do we have a standard notification for this?
          } else {
            this.openWarningModal('An unexpected error has occurred; please try again.');
            console.error(`No question data found for assignment: ${activityInstanceId}`); // TODO do we have a standard notification for this?
          }
          this.setState({ responseData: null, questionData: [], instanceStatus, forceStudentNavigation: true });
        }
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  async updateInstanceGradebookScores(instanceId) {
    this.props.handleUpdateLearnosityScores(instanceId);
  }

  async closeGradingApp(doClose=true) {
    const { isTeacher, t } = this.props;
    console.log(`in closeGradingApp: doClose: ${doClose}`);//remove
    try {
      if (this.gradingApp && isTeacher) {
        try {
          await this.saveGradingApp(false); 
        } catch (e) {
          // if there are no grades to save
          if (e.code !== 70015) {
            throw e;
          }
        } 
        const appCleared = await this.clearGradingApp(doClose, false);
      } else {
        // no grading app to reset, just close
        this.setState({ doClose, instanceStatus: '' });
      }
    } catch (e) {
      console.log(`closeGradingApp: code ${e.code} message: ${e.message}`);
      // 70012 and 70014 are validation errors for unsaved changes or invalid input.
      if (e.code === 70012) {
        this.openWarningModal(t('unsavedChangedMessage'));
      } else if (e.code === 70014) {
        this.openWarningModal(t('invalidInputMessage'));
      } else if (e.code === 70015) {
        // just ignore this code as we are closing
        const appCleared = await this.clearGradingApp(doClose, false);
      } else {
        throw e;
      }
      this.setState({ isSaving: false, saveComplete: true });
    }
  }

  async saveGradingApp(showSaveSuccess = true) {
    const { curActivityInstanceId } = this.state;
    let saveResult = null;
    try {
      if (this.gradingApp) {
        saveResult = await this.gradingApp.save();
        this.updatedResponses = true;
        await this.updateInstanceGradebookScores(curActivityInstanceId);
        if (showSaveSuccess) {
          this.showSaveSuccessMessage();
        }
        this.processAttachedItems(false);
        this.setState({ isSaving: false, saveComplete: true });
      }
    } catch (e) {
      console.log(`saveGradingApp: code ${e.code} message: ${e.message}`);
      this.setState({ isSaving: false, saveComplete: true });
      throw e;
    }
    return saveResult;
  }

  async clearGradingApp(doClose = false, showErrorMessages = true) {
    const { t } = this.props;
    console.log('in clearGradingApp');//remove
    // reset the grading app.  
    if (this.gradingApp != null) {
      try {
        const resetResult = await this.gradingApp.reset();
        this.gradingApp = null;
        await this.clearGradingHooks();
        this.setState({ doClose, instanceStatus: '' });
        return true;
      } catch (e) {
        // in some cases, like on close, just ignore the errors.
        if (showErrorMessages) {
          // 70012 and 70014 are validation errors for unsaved changes or invalid input.
          if (e.code === 70012) {
            this.openWarningModal(t('unsavedChangedMessage'));
          } else if (e.code === 70014) {
            this.openWarningModal(t('invalidInputMessage'));
          } else if (e.code === 70015) {
            // just ignore this code as we are closing
          } else {
            this.openWarningModal(`${e.message}`);
          }
        }
        this.setState({ isSaving: false, saveComplete: true, instanceStatus: '' });
      }
      return false
    } else {
       this.setState({ doClose, instanceStatus: '' });
    }
    return true;
  }

  async clearGradingHooks() {
     const hookElement = document.querySelector('#l-scoring-card-outer-container');
     if (hookElement && hookElement.hasChildNodes()) {
      let child = hookElement.lastElementChild;
        while (child) {
            hookElement.removeChild(child);
            child = hookElement.lastElementChild;
        }
     }

  }

  async showSaveSuccessMessage() {
    const { dialogManager, t } = this.props;
      let title = 'Save'
      let message = t('saveSuccessMessage');
      dialogManager.setOpenDialog(DIALOG_NAMES.TEXT, {
        title,
        message
      }, () => dialogManager.closeDialog(DIALOG_NAMES.TEXT));
  }

  // adds a css stylesheet to the dom
  setLearnosityStylesheet(learnosityStylesheet) {
    if (learnosityStylesheet) {
      // if a link exists, delete it.
      const existingStylesheet = document.querySelector('#learnosity-stylesheet');
      if (existingStylesheet) {
        existingStylesheet.parentNode.removeChild(existingStylesheet);
      }
      // create the link
      const link = document.createElement('link');
      link.href = learnosityStylesheet;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.id = 'learnosity-stylesheet';
      document.body.appendChild(link);
    }
  }

  async startLoadGradingApp() {
    const { isGradingAPILoaded } = this.state;
    // load the grading app
    // poll/wait for Learnosity javascript to load
    if (!isGradingAPILoaded) {
      const interval = await setInterval(async () => {
        if (window.LearnosityGrading && !this.state.cancelStart) {
          // stop polling
          clearInterval(interval);
          // render the grading api
          await this.loadGrading();
        }
      }, 1000);
    }
  }

  async loadGrading() {
    const { learnosityItemsManager } = this.props;
    const { curActivityInstanceId } = this.state;
    learnosityItemsManager.getLearnosityItemsInlineGradingApiRequest(curActivityInstanceId, true).then((requestJson) => {
      const data = JSON.parse(requestJson.data);
      const sessionId = requestJson.sessionId;
      this.setState({activitySessionId: sessionId});

      // Initialize the grading api
      const hookElement = document.querySelector('#l-scoring-card-outer-container');
      console.log('in loadGrading before grading init');//remove
      window.LearnosityGrading.init(JSON.parse(data.init), hookElement).then( async (app) => {
        this.gradingApp = app;
        if (this.gradingApp) {
          this.setGradingAPIEvents();
          console.log('in loadGrading then of grading init: about to set isGradingAPILoaded: true');//remove
          this.setState({isGradingAPILoaded: true});
        }
      }).catch((error) => {
        console.log(error);
      });
    }).catch((err) => {
      this.openWarningModal(err);
      this.setState({ cancelStart: true });
    });
  }

  setGradingAPIEvents () {
    console.log('in setGradingAPIEvents');//remove

    this.gradingApp.on('attachitem:error', function () {
        console.log('attachItem fail');
    });

    this.gradingApp.on('attachitem:start', () => {
        console.log('attachItem started');
        this.setState({ showAttachingSpinner: true });
    }, this);

    this.gradingApp.on('attachitem:complete', () => {
      const { itemCount, attachedItemCount } = this.state;
      console.log('attachItem complete');
      const newAttachedCount = attachedItemCount + 1;
      // Get the attached items
      if (itemCount === newAttachedCount) {
        this.processAttachedItems();
      }
      this.setState({ attachedItemCount: newAttachedCount });
    }, this);

    this.gradingApp.on('save:start', () => {
        console.log('save: start');
        this.setState({ isSaving: true, saveComplete: false });
    }, this);

    this.gradingApp.on('save:complete', () => {
        console.log('save: complete');
    }, this);

    this.gradingApp.on('save:error', function () {
      console.log('save fail');
    });

    this.gradingApp.on('reset:complete', function () {
      console.log('reset succeeed');
    });

    this.gradingApp.on('reset:error', function () {
      console.log('reset fail');
    });

  }

  processAttachedItems (renderSampleAnswer = true) {
    const { isTeacher } = this.props;
    // Get the attached items so we can extract the metadata.
    const attachedItemsResponse = this.gradingApp.getAttachedItems();
    const itemsArray = attachedItemsResponse[0]?.items;
    let overallItemScore = 0;
    let overallMaxScore = 0;
    let unscoredItemsCount = 0;
    for (const item of itemsArray) {
      const questionsArray = item?.questions;
      for (const question of questionsArray) {
        // Find the question hook in the attached by the grader api
        if (document.getElementById(question.response_id)) {
          const sampleAnswer = question?.metadata?.sample_answer;
          if (renderSampleAnswer && isTeacher && sampleAnswer && sampleAnswer.length > 0) {
            this.renderSampleAnswer(question, sampleAnswer);
          }
        }
      }
      const gradesArray = item?.grades;
      for (const grade of gradesArray) {
        const itemGradeScore = grade.score;
        if (itemGradeScore) {
          if (itemGradeScore.score === null) {
            unscoredItemsCount++;
          }
          overallItemScore += itemGradeScore.score;
          overallMaxScore += itemGradeScore.maxScore;
          console.log(`processAttachedItems: itemScore: ${itemGradeScore.score} itemMaxScore: ${itemGradeScore.maxScore}`);//remove
        }
      }
    }
    const overallScore = Number((overallItemScore / overallMaxScore) * 100).toFixed(2);
    console.log(`processAttachedItems: score: ${overallScore} unscoredItemCount: ${unscoredItemsCount}`);//remove
    this.setState({ overallScore, allItemsAttached: true, showAttachingSpinner: false, unscoredItemsCount });
  }

  renderSampleAnswer (question, sampleAnswer) {
    const questionHook = document.getElementById(question.response_id); // find the question in the dom
    if (questionHook) {
      const sampleAnswerWrapper = document.createElement('DIV'); // create sample answer wrapper
      sampleAnswerWrapper.className = 'question-sample-answer-wrapper';
      const divId = `sample-answer-${question.response_id}`;
      sampleAnswerWrapper.innerHTML = 
      `<div id='${divId}' class='question-sample-answer-header'>
            Teacher Guidance
        </div>
        <div id='${divId}' class='question-sample-answer-container'>
            ${sampleAnswer}
        </div>`;
      questionHook.appendChild(sampleAnswerWrapper);
    }
  }

  handleOpenInfo = () => {
    this.setState({ addInfoOpen: true });
  }

  closeInfoModal = () => {
    this.setState({ addInfoOpen: false });
  }

  openWarningModal = (message) => {
    this.setState({ showErrorDialog: true, errorMessage: message });
  }

  closeWarningModal = () => {
    this.setState({ showErrorDialog: false, errorMessage: '' });
  }

  handleSubmitSessionConfirm = (activityInstanceId, message = null) => {
    const { dialogManager, t } = this.props;
    const title = t('confirmSubmitActivityTitle');
    const dialogMessage = message ? message : t('confirmSubmitActivityMsg');
    dialogManager.setOpenDialog(DIALOG_NAMES.CONFIRM, {
      title,
      message: dialogMessage,
      cancelButtonClass: 'keepButton',
      cancelButtonName: 'Cancel',
      confirmButtonClass: 'deleteButton',
      confirmButtonName: 'Submit',
      confirmHandler: () => {
        dialogManager.closeDialog(DIALOG_NAMES.CONFIRM);
        this.createStudentSessionSubmission(activityInstanceId);
        this.setState({instanceStatus: 'pending-submit'});
      }
    },
    () => dialogManager.closeDialog(DIALOG_NAMES.CONFIRM));
  };

  async createStudentSessionSubmission(activityInstanceId) {
    const { learnosityDataManager } = this.props;
    learnosityDataManager.createStudentSessionSubmission(activityInstanceId);
    // TODO, show info modal 
  }

  renderStudentInstructionButton = () => {
    const { instruction, isTeacher, t} = this.props;
    if (instruction && instruction !== '<p></p>') {
      return (
        <Button
          className={(!isTeacher ? 'basic student-instruction white' : 'basic white')}
          onClick={() => this.handleOpenInfo()}
          primary>
          {t('studentInstructionsButtonLabel')}
        </Button>
      );
    }
    return null;
  }

  // create a hook div and attach to the wrapper for learnosity to load each grading item to render
  renderGradingItems = async () => {
    const { userManager, assignerId, isTeacher, t } = this.props;
    const { activitySessionId, questionData, curStudentId, curActivityInstanceId } = this.state;
    const questionRefs = questionData;
    console.log('in renderGradingItems - should be after init returns.');//remove
    this.setState({ renderingItems: true });

    if (questionRefs != null) {
      if (questionRefs.length > 0) {
        this.setState({ itemCount: questionRefs.length });
        const wrapperElement = document.querySelector('#l-scoring-card-outer-container');
        if (wrapperElement) {
          for (let i = 0; i < questionRefs.length; i++) {
            // questions can have objects or strings for references
            const questionRef = questionRefs[i];
            const itemRefId = (typeof questionRef === 'object') ? questionRef.reference : questionRef;
            const itemHookElement = document.createElement('DIV');

            const payload = {
                sessionId: activitySessionId,
                userId: (curStudentId && isTeacher) ? curStudentId : userManager.userId,
                item: itemRefId
            };

            const hookUserId = (assignerId && !isTeacher) ? assignerId : userManager.userId;

            itemHookElement.setAttribute('session-id', activitySessionId);
            itemHookElement.setAttribute('user-id', hookUserId);
            itemHookElement.setAttribute('item-reference', itemRefId);
            itemHookElement.className = `lrn-mg-item-hook`;
            wrapperElement.appendChild(itemHookElement);

            try {
              await this.gradingApp.attachItem(payload, itemHookElement);
            } catch (e) {
                console.log(`renderGradingItems: code ${e.code} message: ${e.message}`);
                // If the error is 70013: no grade found, it's because the student started but closed the test without answering the items and didn't submit.
                // So we give the teacher the option to submit.
                if (e.code === 70013) {
                  this.handleSubmitSessionConfirm(curActivityInstanceId, t('confirmSubmitActivityNoGradeMsg')) ;
                  this.setState({ showSubmissionMessage: true });
                  // stop processing the items.
                  break;
                } else {
                  throw e;
                }
            }

          }
        }
      }
    }
  }

  openPrintComponent = async () => {
    const { classroomId, contentTitle, contentSubTitle, grade } = this.props;
    const { curActivityInstanceId, studentName } = this.state;
    await this.clearGradingApp();
    // Some string params are in session storage because they could contain reserved url chars.
    const instanceData = {
      contentTitle,
      contentSubTitle,
      points: this.totalPoints,
      studentName,
      maxPoints: this.totalMaxPoints,
      grade
    };
    setSessionStorageItem('c2c_printPreviewData', JSON.stringify(instanceData));

    this.props.history.push(`/lrnPrint?activityInstanceId=${curActivityInstanceId}&assignmentId=${assignmentId}&classroomId=${classroomId}&returnView=${VIEW_SELECTION.GRADEBOOK}`);
  }

  saveTeacherScores = async (showSaveSuccess = true, showErrorMessages = false, forceActivityInstanceId = null) => {
    const { t } = this.props;
    const { curActivityInstanceId } = this.state;
    console.log('in saveTeacherScores');//remove
    const activityInstanceId = forceActivityInstanceId ? forceActivityInstanceId : curActivityInstanceId;
    if (this.gradingApp) {
      try {
        try {
          await this.saveGradingApp(showSaveSuccess); 
        } catch (e) {
          // if there are no grades to save
          if (e.code !== 70015) {
            throw e;
          }
        }
        await this.clearGradingApp(false, showErrorMessages);
        await this.getLearnosityData(activityInstanceId);
        this.setState({ isGradingAPILoaded: false, renderingItems: false, itemCount: 0, attachedItemCount: 0, responseData: null, questionData: [], instanceStatus: 'ready', overallScore: 0, 
          forceStudentNavigation: false, allItemsAttached: false, unscoredItemsCount: 0});
        return true;
      } catch (e) {
        console.log(`saveTeacherScores: code ${e.code} message: ${e.message}`);
        // 70012 and 70014 are validation errors for unsaved changes or invalid input.
        if (e.code === 70012) {
          this.openWarningModal(t('unsavedChangedMessage'));
        } else if (e.code === 70014) {
          this.openWarningModal(t('invalidInputMessage'));
        } else if (e.code === 70015) {
          // ignore this as it just means there are no grades to save.
        } else {
          this.openWarningModal(`${e.message}`);
        }
        this.setState({ isSaving: false, saveComplete: true });
        return false;
      }
    } else {
      // if no grading app to worry about, just continue as if save succeeded
      await this.getLearnosityData(activityInstanceId);
      this.setState({ isGradingAPILoaded: false, renderingItems: false, itemCount: 0, attachedItemCount: 0, responseData: null, questionData: [], instanceStatus: 'ready', overallScore: 0, 
      forceStudentNavigation: false, allItemsAttached: false, unscoredItemsCount: 0});
      return true;
    }
  }

    navigateNextStudent = async () => {
    const { activityInstances, t } = this.props;
    const { curActivityInstanceId, unscoredItemsCount } = this.state;
    try {
      // Check if there are unscored items 
      if (unscoredItemsCount > 0) {
          this.openWarningModal(t('unscoredItemsMessage'));
          return false;
      }
      const instancesArray = Array.from(activityInstances);   
      const currentInstanceIdx = instancesArray.findIndex(instance => instance.id === curActivityInstanceId);
      const nextIndex = currentInstanceIdx === instancesArray.length - 1 ? 0 : currentInstanceIdx + 1;
      const nextInstance = instancesArray[nextIndex];
      const nextActivityInstanceId = nextInstance.id;
      const nextStudentName = `${nextInstance.firstName} ${nextInstance.lastName}`;

      // before navigating away, try to save in case there were changes.  If none, an exception will be thrown so just ignore it.
      const succeeded = await this.saveTeacherScores(false, true, nextActivityInstanceId);
      if (succeeded) {
        this.setState({ curActivityInstanceId: nextActivityInstanceId, curStudentId: nextInstance.userId, studentName: nextStudentName,  
          showSubmissionMessage: false, isStudentStarted: false, isStudentSubmitted: false
        });
      }
    } catch (e) {
      console.log(`code ${e.code} message: ${e.message}`);
      this.openWarningModal(e.message);
      this.setState({ isSaving: false, saveComplete: true });
    }
  }

  navigatePreviousStudent = async () => {
    const { activityInstances, t } = this.props;
    const { curActivityInstanceId, unscoredItemsCount } = this.state;
    try {
      // Check if there are unscored items 
      if (unscoredItemsCount > 0) {
          this.openWarningModal(t('unscoredItemsMessage'));
          return false;
      }
      const instancesArray = Array.from(activityInstances);   
      const currentInstanceIdx = instancesArray.findIndex(instance => instance.id === curActivityInstanceId);
      const prevIndex = currentInstanceIdx === 0 ? instancesArray.length - 1 : currentInstanceIdx - 1;
      const prevInstance = instancesArray[prevIndex];
      const prevActivityInstanceId = prevInstance.id;
      const prevStudentName = `${prevInstance.firstName} ${prevInstance.lastName}`;

      // before navigating away, try to save in case there were changes.  If none, an exception will be thrown so just ignore it.
      const succeeded = await this.saveTeacherScores(false, true, prevActivityInstanceId);
      if (succeeded) {
        this.setState({ curActivityInstanceId: prevActivityInstanceId, curStudentId: prevInstance.userId, studentName: prevStudentName, 
          showSubmissionMessage: false, isStudentStarted: false, isStudentSubmitted: false
        });
      }
    } catch (e) {
      console.log(`code ${e.code} message: ${e.message}`);
      this.openWarningModal(e.message);
      this.setState({ isSaving: false, saveComplete: true });
    }
  }

  ProgressBar = (props) => { 
    const { color, percent } = props;
    return (
      <div className={`progress-bar ${color}`}>
        <div className={color} style={{ width: `${percent}%`, maxWidth: '100%' }} />
      </div>
    );
  }

  toggleStudentName () {
    const { showStudentName } = this.state;
    const newShowStudentName = !showStudentName;
    this.setState({ showStudentName: newShowStudentName });
  }

  render() {
    const { InfoModal } = this;
    const { ErrorModal } = this;
    const { ProgressBar } = this;
    const { assignmentManager, gradebookManager, t } = this.props;
    const { allItemsAttached, attachedItemCount, forceStudentNavigation, overallScore, isGradingAPILoaded, isStudentStarted, isStudentSubmitted, showAttachingSpinner, 
      showSubmissionMessage, showStudentName, instanceStatus } = this.state;
    const gradeClassName = gradebookManager.getGradeClassName(overallScore);
    const processedContentTitle = this.props.contentTitle ? UtilityService.reactHtmlParserWrapper(this.props.contentTitle).parsedNoPWrap : '';
    const processedContentSubTitle = this.props.contentSubTitle ? UtilityService.reactHtmlParserWrapper(this.props.contentSubTitle).parsedNoPWrap : '';
    const displayTitle = this.props.contentSubTitle ? processedContentTitle + ': ' + processedContentSubTitle : processedContentTitle;
    console.log(`in render: instanceStatus: ${instanceStatus} showSubmissionMessage ${showSubmissionMessage} isStudentStarted: ${isStudentStarted} isStudentSubmitted: ${isStudentSubmitted} attachedItemCount: ${attachedItemCount}`);//remove
    return (
      <div className='learnosity-modal-container'>
        <Modal
          className='l-scoring-modal'
          onMount={() => document.body.classList.add('body-l-scoring-modal')}
          onUnmount={() => document.body.classList.remove('body-l-scoring-modal')}
          open
          size='fullscreen'>
          <div className='l-scoring-modal-container'>
            <div className='l-scoring-modal-upper-header'>
              <Popup
                content={displayTitle}
                on='hover'
                position='bottom center'
                trigger={(
                  <div className='scoring-modal-title-text'>
                    <div className='scoring-title-text'>
                      {displayTitle}
                    </div>
                  </div>
                )}
                wide
              />
              {!this.props.isTeacher && (
                <div className='progress-bar-container'>
                  <div className={`progress-text ${gradeClassName}`}>
                    {this.props.grade}
                    %
                  </div>
                  <ProgressBar color={gradeClassName} percent={this.props.grade} />
                </div>
              )}
              {this.props.isTeacher && allItemsAttached && (
                <div className='progress-bar-container'>
                  <div className={this.state.showStudentName ? `progress-text ${gradeClassName}` : `progress-text ${gradeClassName} obscured`}>
                    {this.state.overallScore}
                    %
                  </div>
                </div>
              )}
              {this.props.isTeacher && this.props.canManageScores && (
                <Button
                  className={'previous-student-button'}
                  disabled={(!isGradingAPILoaded || showAttachingSpinner) && !forceStudentNavigation}
                  onClick={() => this.navigatePreviousStudent()}
                  primary>
                  {this.state.isSaving ? <Loader active inline size='tiny' /> : t('prevStudentButtonLabel')}
                </Button>
              )}
              {this.props.isTeacher && (
                <Popup
                  content={this.state.studentName}
                  on='hover'
                  position='bottom center'
                  trigger={(
                    <div className='scoring-modal-title-text'>
                        <div className={showStudentName ? 'scoring-title-text' : 'scoring-title-text obscured'}>
                          {this.state.studentName}
                        </div>
                    </div>
                  )}
                  disabled={!showStudentName}
                  wide
                />
              )}
              {this.props.isTeacher && this.state.studentName && (
                <div className='hide-student-name-toggle-wrapper'>
                  <Checkbox
                    checked={!showStudentName}
                    className='hide-student-name-toggle'
                    disabled={this.state.isSaving}
                    onChange={() => this.toggleStudentName()}
                    toggle />
                </div>
               )}
              {this.props.isTeacher && this.props.canManageScores && (
                <Button
                  className={'next-student-button'}
                  disabled={(!isGradingAPILoaded || showAttachingSpinner) && !forceStudentNavigation}
                  onClick={() => this.navigateNextStudent()}
                  primary>
                  {this.state.isSaving ? <Loader active inline size='tiny' /> : t('nextStudentButtonLabel')}
                </Button>
              )}
              <div className='modal-title-button'>
                {this.renderStudentInstructionButton()}
                {isGradingAPILoaded && !showAttachingSpinner && this.props.isTeacher && this.props.canManageScores && assignmentManager.usePrintPreview && (
                  <Button
                    className={(!this.props.isTeacher ? 'basic student white' : '')}
                    onClick={() => this.openPrintComponent()}
                    primary>
                    Print Preview
                  </Button>
                )}
                <Button
                  className={(!this.props.isTeacher ? 'basic student white' : '')}
                  disabled={(!this.state.saveComplete || showAttachingSpinner)}
                  onClick={() => this.closeGradingApp()}
                  primary>
                  {t('closeButtonLabel')}
                </Button>
                {this.props.isTeacher && this.props.canManageScores && (
                  <Button
                    className={(!this.props.isTeacher ? 'basic student white' : '')}
                    disabled={(!isGradingAPILoaded || showAttachingSpinner)}
                    onClick={() => this.saveTeacherScores()}
                    primary>
                    {this.state.isSaving ? <Loader active inline size='tiny' /> : t('saveButtonLabel')}
                  </Button>
                )}
              </div>
            </div>
            {showSubmissionMessage && (!isStudentStarted && !isStudentSubmitted) &&
              <div className='l-scoring-card-message-container' id='l-scoring-card-outer-container-started'>The assignment was not started or submitted by the student</div>
            }
            {showSubmissionMessage && (isStudentStarted && attachedItemCount === 0) &&
              <div className='l-scoring-card-message-container' id='l-scoring-card-outer-container-started'>The assignment was started but there are no responses to display</div>
            }
            {showSubmissionMessage && instanceStatus.includes?.('pending') &&
              <div className='l-scoring-card-message-container' id='l-scoring-card-outer-container-submitted'>The student assignment is pending submission/scoring, try again later <Loader active inline size='large' /> </div>
            }
            <div className='l-scoring-card-outer-container' id='l-scoring-card-outer-container'>
              {showAttachingSpinner && 
                <Loader active inline size='massive' />
              }
            </div>
          </div>
          <InfoModal
            addInfoOpen={this.state.addInfoOpen}
            closeInfoModal={this.closeInfoModal}
            contentItemDescription={null}
            imageUrl={this.props.contentImageUrl}
            infoName={this.props.resourceName}
            resourceInfo={null}
            studentInstruction={this.props.instruction} />
          <ErrorModal
            addErrorOpen={this.state.showErrorDialog}
            closeErrorModal={this.closeWarningModal}
            errorMessage={this.state.errorMessage} />
        </Modal>
      </div>
    );
  }
}

SatCoreRegister('LearnosityScoringModal', LearnosityScoringModal);
